import React, { Component } from 'react';
import { Element } from 'react-scroll'
import {Container,Row,Col } from 'react-bootstrap'
import "./index.css"
class Footer extends Component {
    state = {}
    render() {
        return (
            <Element id='contacts' name='contacts'>

                <footer className="footer">
                    <Container>

                        <Row className="justify-content-center">
                            <h3 >Контакти:</h3>
                        </Row>

                        <Row style={{ marginTop: "2%", marginBottom: "2%" }} className="justify-content-md-center listcontacts">

                            <Col xl={3}  lg={3} md={3}  xs={8}>
                                <li> Телефон: <a href="tel:+38 097 27 88 722">+38 097 27 88 722</a></li>
                            </Col>
                            <Col xl={3}  lg={3} md={3}  xs={8}>
                                <li>Email: <a href="mailto:polevik-@ukr.net">polevik-@ukr.net</a></li>
                            </Col>
                            <Col xl={3}  lg={3} md={3}  xs={8}>
                                <li >Facebook: <a href="https://m.facebook.com/PolevikFOP/">PolevikFOP</a></li>
                            </Col>
                            <Col xl={3}  lg={3} md={3}  xs={8}>
                                <li>    м.Рівне</li>
                            </Col>

                        </Row>

                    </Container>


                </footer>

            </Element>



        );
    }
}

export default Footer;




